module.exports = __webpack_public_path__ + "img/icon_map_6_on_110.46ee519a.png";